<!-- 会员服务-服务订单-积分充值 -->

<template>
  <div class="points-recharge main-cnt">
    <div class="content">
      <common-table ref="tableRef" tableHeight="calc(100vh - 320px)" :ischeck="false" :filters="filters"
        :needExport="true" :ispaging="true" :apiName="VipApi.getIntegralOrderList" :columns="tableColumns"
        @onDetailsBtn="onDetailsBtn" @onRefundBtn="onRefundBtn">
        <template #pay_status="{ row }">
          <div class="flex align-center">
            <div class="status-text" :class="statusColors(row.or_pay_status)">{{ row.or_status_text }}</div>
          </div>
        </template>
      </common-table>
    </div>

    <!-- 详情 -->
    <RechargeDetails ref="refInfo"></RechargeDetails>

    <!-- 退款确认 -->
    <w-dialog ref="dialogRef" title="退款确认" width="40%" btnWidth="140px" top="20vh" confirmText="确认退款"
      @wConfirm="handleSure">
      <el-form ref="formRef" :model="ruleForm" :rules="rules" labelPosition="top">
        <el-form-item label="可退金额" prop="refund_money">
          <el-input v-model="ruleForm.refund_money" readonly placeholder="请输入可退金额"></el-input>
        </el-form-item>
        <el-form-item label="可退积分数量" prop="less_integration">
          <el-input v-model="ruleForm.less_integration" readonly placeholder="请输入可退积分数量"></el-input>
        </el-form-item>
        <el-form-item class="block" label="退款原因" prop="refund_reason">
          <el-input v-model="ruleForm.refund_reason" :rows="5" type="textarea" placeholder="请输入退款原因" />
        </el-form-item>
      </el-form>
    </w-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, reactive, } from "vue";
import { VipApi, } from "@/plugins/api.js";
import { ElMessage, } from "element-plus";
import { useStore } from "vuex";
import RechargeDetails from '../components/RechargeDetails.vue';

// 权限
const store = useStore();
const menuTokens = computed(() => store.state.menuToken.menuTokens);
const authData = ref([]);
watch(
  () => menuTokens.value,
  (data) => {
    if (data.length) {
      authData.value = data;
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

onMounted(() => {
  tableRef.value.tableLoad();
});

const filters = ref([
  {
    filterType: "search",
    name: "keywords",
    value: "",
    placeholder: "请输入会员手机号",
  },
  {
    filterType: "select",
    name: "pay_status",
    value: "",
    placeholder: "请选择支付状态",
    options: [
      { value: 1, name: '待支付' },
      { value: 2, name: '已支付' },
      { value: 3, name: '已取消' },
      { value: 4, name: '退款中' },
      { value: 5, name: '已退款' },
    ],
    val: "value",
    lab: "name",
  },
  {
    filterType: "date",
    name: "stime",
    name2: "etime",
    value: [],
    placeholder: "请选择日期",
    type: "daterange",
  },
]);
/** 表格对象 */
const tableRef = ref(null);
/** 表格配置数据 */
const tableColumns = ref([
  {
    prop: "or_sn",
    label: "订单号",
  },
  {
    prop: "im_title",
    label: "商品名称",
  },
  {
    prop: "or_money",
    label: "订单金额",
  },
  {
    prop: "m_mobile",
    label: "会员手机",
  },
  {
    prop: "pay_status",
    type: "customRender",
    label: "支付状态",
  },
  {
    prop: "or_pay_time",
    label: "支付时间",
  },
  {
    prop: "orp_name",
    label: "支付方式",
  },
  {
    prop: "or_refund_money",
    label: "退款金额",
  },
  {
    prop: "or_refund_time",
    label: "退款时间",
  },
  {
    type: "operation",
    prop: "",
    label: "操作",
    minWidth: 190,
    bottons: [
      {
        name: "详情",
        action: "onDetailsBtn",
        className: "theme-font-btn",
        token: "m_orderuujvoidcsvn232dsvccsd12",
      },
      {
        name: "退款",
        action: "onRefundBtn",
        HiddenKey: "can_refund",
        showValue: [1],
        className: "theme-font-btn",
        token: "n_ab47a78f7fa194e2313bf2fba",
      },
    ],
  },
]);
const refInfo = ref(null);  // 详情对象
const dialogRef = ref(null);  // 退款
const formRef = ref(null);  // 表单对象
// 填写表单内容
const ruleForm = ref({
  sn: '',  // 订单号
  refund_money: '',  // 退款金额
  less_integration: '',  // 可退积分
  refund_reason: '',  // 退款说明
});
// 验证必填项
const rules = reactive({
  // refund_money: [
  //   { required: true, message: "请输入退款金额", trigger: "blur", },
  // ],
});
/**
 * 
 *  状态样式
 * 
 */
const statusColors = (status) => {
  let status_color = '';  // 1-待交 2-已支付 3-订单取消 4-申请退款中 5-已退款
  switch (status) {
    case 1:
      status_color = 'btn-red';
      break;
    case 2:
      status_color = 'btn-green';
      break;
    case 3:
      status_color = 'btn-grey';
      break;
    case 4:
      status_color = 'btn-grey';
      break;
    case 5:
      status_color = 'btn-black';
      break;
  }
  return status_color;
}
/**
 * 
 * 详情按钮
 * 
 * **/
const onDetailsBtn = (row) => {
  refInfo.value.openDialog(row);
}
/**
 * 
 * 退款按钮
 * 
 * **/
const onRefundBtn = (row) => {
  ruleForm.value.sn = row.or_sn;
  ruleForm.value.refund_money = row.less_integration_money;
  ruleForm.value.less_integration = row.less_integration;
  dialogRef.value.show();
}
/**
 * 
 * 确认退款按钮
 * 
 * **/
const handleSure = () => {
  formRef.value.validate((valid) => {
    if (valid) {
      dialogRef.value.isLoading = true;
      VipApi.integralOrderRefund(ruleForm.value).then((res) => {
        dialogRef.value.isLoading = false;
        if (res.Code === 200) {
          ElMessage.success('退款成功！');
          dialogRef.value.close();
          tableRef.value.tableLoad();
        } else {
          ElMessage.error(res.Message);
        }
      });
    }
  })
}

</script>
<style lang="scss">
.points-recharge {
  font-family: "Source Han Sans CN";

  .content {
    padding: 15px 20px 20px;
  }
}
</style>